import React, { useEffect, useState } from "react";
import logger from "../utilitis/logger";
import { List, ListItem, ListItemText, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemButton from "@mui/material/ListItemButton";
import Collapse from "@mui/material/Collapse";
import moment from "moment";
import "moment/locale/he";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Popover,
  CircularProgress,
  Alert,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";
import LoadingBox from "./Loading";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Divider from "@mui/material/Divider";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import statusorder from "../list/statusorder";
import {
  CheckCircle,
  Home,
  Build,
  LocalMall,
  Flight,
  DeliveryDining,
  CheckCircleOutline,
} from "@mui/icons-material";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#dfedf5",
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 15,
  },
}));

const OpenList = ({ clicked, data }) => {
  const [expanded, setExpanded] = useState(null);
  const [expandedClosed, setExpandedClosed] = useState(null);
  const [openorders, setOpenorders] = useState([]);
  const [closeorders, setcloseorders] = useState([]);
  const [loadBox, setLoadBox] = useState(false);
  const [skip, setSkip] = useState({ value: false, skip: 0 });

  // State for tracking popover
  const [anchorEl, setAnchorEl] = useState(null);
  const [trackingData, setTrackingData] = useState(null);
  const [trackingLoading, setTrackingLoading] = useState(false);
  const [trackingError, setTrackingError] = useState("");
  const [currentOrderNumber, setCurrentOrderNumber] = useState("");
  const closeTimeoutRef = React.useRef(null);

  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_NEO_SERVICE;

  // כל הסטטוסים האפשריים לפי הסדר
  const ALL_STATUSES = [
    { name: "קליטת הזמנה", icon: Home },
    { name: "ההזמנה בטיפול", icon: Build },
    { name: "ליקוט ואריזה", icon: LocalMall },
    { name: "הוזנה למשלוח", icon: Flight },
    { name: "משלוח בדרך", icon: DeliveryDining },
    { name: "משלוח הגיע", icon: CheckCircleOutline },
  ];

  const handleExpand = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  const handleExpandClosed = (index) => {
    setExpandedClosed(expandedClosed === index ? null : index);
  };

  // Fetch order tracking data
  const fetchTrackingData = async (orderNumber) => {
    setTrackingLoading(true);
    setTrackingError("");
    setTrackingData(null);

    try {
      const response = await axios.get(
        `${API_URL}/order-tracking/api/orders/${orderNumber}/track`
      );
      setTrackingData(response.data);
    } catch (error) {
      logger.error("Error fetching tracking data:", error);
      setTrackingError("לא ניתן לטעון מעקב הזמנה");
    } finally {
      setTrackingLoading(false);
    }
  };

  // Handle mouse enter on order number
  const handleOrderNumberHover = (event, orderNumber) => {
    // ביטול timeout של סגירה אם קיים
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }

    setAnchorEl(event.currentTarget);
    setCurrentOrderNumber(orderNumber);
    fetchTrackingData(orderNumber);
  };

  // Handle mouse leave
  const handleClosePopover = () => {
    // השהייה קטנה לפני סגירה
    closeTimeoutRef.current = setTimeout(() => {
      setAnchorEl(null);
      setTrackingData(null);
      setTrackingError("");
      setCurrentOrderNumber("");
    }, 300);
  };

  // Cancel close when mouse enters popover
  const handlePopoverMouseEnter = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
  };

  const open = Boolean(anchorEl);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleString("he-IL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // ✅ פונקציה ליצירת טיימליין - מלא או חלקי לפי הסטטוס
  const getFullTimeline = () => {
    if (!trackingData || !trackingData.steps || trackingData.steps.length === 0)
      return [];

    const steps = trackingData.steps;

    // ✅ בדיקה האם "משלוח הגיע" קיים - עם trim ו-includes
    const hasDeliveryCompleted = steps.some(
      (step) =>
        step.status?.trim().includes("משלוח הגיע") ||
        step.status?.trim() === "משלוח הגיע"
    );

    // ✅ אם ההזמנה הושלמה - מחזירים רק את הסטטוסים שבאמת התרחשו
    if (hasDeliveryCompleted) {
      return steps.map((step) => {
        const statusDef = ALL_STATUSES.find(
          (s) => s.name === step.status?.trim()
        );
        return {
          name: step.status,
          icon: statusDef ? statusDef.icon : Home,
          date: step.date,
          status: step.isCurrent
            ? "current"
            : step.isCompleted
            ? "completed"
            : "future",
        };
      });
    }

    // ✅ אם ההזמנה עדיין בתהליך - מחזירים טיימליין מלא
    const currentStepIndex = steps.findIndex((s) => s.isCurrent);
    const currentStatusName =
      currentStepIndex >= 0 ? steps[currentStepIndex].status : "";

    const stepsMap = {};
    steps.forEach((step) => {
      stepsMap[step.status] = step;
    });

    return ALL_STATUSES.map((status, index) => {
      const existingStep = stepsMap[status.name];

      let stepStatus = "future";

      if (existingStep) {
        if (existingStep.isCurrent) {
          stepStatus = "current";
        } else if (existingStep.isCompleted) {
          stepStatus = "completed";
        }
      } else {
        const currentIndex = ALL_STATUSES.findIndex(
          (s) => s.name === currentStatusName
        );
        if (currentIndex >= 0 && index < currentIndex) {
          stepStatus = "completed";
        }
      }

      return {
        name: status.name,
        icon: status.icon,
        date: existingStep?.date || null,
        status: stepStatus,
      };
    });
  };

  const getStepColor = (status) => {
    switch (status) {
      case "completed":
        return {
          bg: "#295c9a",
          border: "#295c9a",
          line: "#295c9a",
        };
      case "current":
        return {
          bg: "linear-gradient(135deg, #295c9a 0%, #65b891 100%)",
          border: "#295c9a",
          line: "#295c9a",
        };
      case "future":
      default:
        return {
          bg: "rgb(223, 237, 245)",
          border: "rgb(223, 237, 245)",
          line: "rgb(223, 237, 245)",
        };
    }
  };

  async function fetchData() {
    try {
      let postData = {};

      if (data && (data.fromdate != "" || data.todate != "")) {
        postData = {
          withCredentials: true,
          fromdate: data.fromdate,
          todate: data.todate,
          skip: skip.value ? skip.skip : 0,
        };
      } else if (data && data.ivnum != "") {
        postData = {
          withCredentials: true,
          doc: data.ivnum,
          skip: skip.value ? skip.skip : 0,
        };
      } else {
        postData = {
          withCredentials: true,
          skip: skip.value ? skip.skip : 0,
        };
      }

      const response = await axios.post("orders/getOrders", postData);

      if (response.status === 200) {
        let filteredOrders = response.data.data.filter(
          (order) => order.BOOLCLOSED != "Y"
        );
        let filteredClosedOrders = response.data.data.filter(
          (order) => order.BOOLCLOSED == "Y"
        );
        setSkip(
          response.data.all === "N"
            ? { value: true, skip: skip.skip + 100 }
            : skip
        );
        setOpenorders(filteredOrders);
        setcloseorders(filteredClosedOrders);
        setLoadBox(true);
      }
    } catch (error) {
      if (error.response?.status === 400) {
        setLoadBox(true);
        navigate(`/errormessage`);
      } else if (error.response?.status == 403) {
        setLoadBox(true);
        navigate("/");
      } else if (error.response?.status === 404) {
        setSkip({ value: false, skip: 0 });
        setLoadBox(true);
        setcloseorders([]);
        setOpenorders([
          {
            ORDNAME: "אין הזמנות פתוחות",
            CURDATE: "",
            CUSTDES: "",
            REFERENCE: "",
            TOTQUANT: "",
            DISPRICE: "",
            ERROR: true,
            NEO_APIORDERITEMS_SUBFORM: [
              {
                PARTNAME: "",
                PARTDES: "",
                TQUANT: "",
                PRICE: "",
                QPRICE: "",
              },
            ],
          },
        ]);
      }
    }
  }

  const cleanAndEncodeHebrew = (text) => {
    if (text) {
      const cleanedText = text.replace(/[^\u0590-\u05FF]/g, "");
      const hebrewAlphabet = "אבגדהוזחטיכלמנסעפצקרשת";
      const latinEncoding = "abcdefghijklmnopqrstuvw";

      let textencode = cleanedText
        .split("")
        .map((char) => {
          const index = hebrewAlphabet.indexOf(char);
          return index !== -1 ? latinEncoding[index] : "";
        })
        .join("");

      return statusorder[textencode];
    }
  };

  useEffect(() => {
    fetchData();
  }, [clicked]);

  const timeline = getFullTimeline();

  return (
    <Container maxWidth="xl">
      {skip.value === true ? (
        <Button
          variant="outlined"
          color="primary"
          onClick={fetchData}
          endIcon={<NavigateBeforeIcon />}
          sx={{ float: "right", marginBottom: "1vw" }}
        >
          הבא
        </Button>
      ) : null}

      <Box
        sx={{
          flexGrow: 1,
          display: { xs: "none", md: "block" },
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1rem",
          marginBottom: "3rem",
        }}
      >
        {loadBox ? (
          <>
            <TableContainer component={Paper}>
              {openorders.length > 0 ? (
                <Typography
                  sx={{ padding: "5px", backgroundColor: "#dfedf5" }}
                  variant="h6"
                  component="div"
                  align="center"
                >
                  הזמנות פתוחות
                </Typography>
              ) : null}
              <Table>
                {openorders.length > 0 ? (
                  <TableHead>
                    <TableRow>
                      <StyledTableCell align="center">
                        מספר הזמנה
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        תאריך קליטה
                      </StyledTableCell>
                      <StyledTableCell align="center">שם לקוח</StyledTableCell>
                      <StyledTableCell align="center">הזמנתכם</StyledTableCell>
                      <StyledTableCell align="center">סטטוס</StyledTableCell>
                      <StyledTableCell align="center"></StyledTableCell>
                    </TableRow>
                  </TableHead>
                ) : null}
                <TableBody>
                  {openorders.map((component, index) => (
                    <React.Fragment key={index}>
                      <TableRow
                        key={index}
                        sx={{
                          backgroundColor:
                            expanded === index
                              ? "rgb(219, 217, 217)"
                              : "rgb(245,245,245)",
                        }}
                      >
                        <StyledTableCell
                          align="center"
                          sx={{
                            fontWeight: expanded === index ? "bold" : null,
                            cursor: !component.ERROR ? "pointer" : "default",
                            "&:hover": !component.ERROR
                              ? {
                                  backgroundColor: "#e3f2fd",
                                  color: "#295c9a",
                                }
                              : {},
                          }}
                          onMouseEnter={(e) => {
                            if (!component.ERROR) {
                              handleOrderNumberHover(e, component.ORDNAME);
                            }
                          }}
                          onMouseLeave={handleClosePopover}
                        >
                          {component.ORDNAME}
                        </StyledTableCell>
                        {!component.ERROR ? (
                          <StyledTableCell
                            align="center"
                            sx={{
                              fontWeight: expanded === index ? "bold" : null,
                            }}
                          >
                            {moment(component.CURDATE).format("L")}
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell></StyledTableCell>
                        )}
                        <StyledTableCell
                          align="center"
                          sx={{
                            fontWeight: expanded === index ? "bold" : null,
                          }}
                        >
                          {component.CUSTDES}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          sx={{
                            fontWeight: expanded === index ? "bold" : null,
                          }}
                        >
                          {component.REFERENCE}
                        </StyledTableCell>
                        {!component.ERROR ? (
                          <StyledTableCell
                            align="center"
                            sx={{
                              fontWeight: expanded === index ? "bold" : null,
                            }}
                          >
                            {cleanAndEncodeHebrew(component.ORDSTATUSDES)}
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell></StyledTableCell>
                        )}
                        {!component.ERROR ? (
                          <TableCell align="center">
                            <IconButton onClick={() => handleExpand(index)}>
                              {expanded === index ? (
                                <ExpandLessIcon />
                              ) : (
                                <ExpandMoreIcon />
                              )}
                            </IconButton>
                          </TableCell>
                        ) : (
                          <StyledTableCell></StyledTableCell>
                        )}
                      </TableRow>
                      {expanded === index ? (
                        <>
                          <TableRow>
                            <StyledTableCell align="center">
                              <Typography
                                variant="caption"
                                sx={{
                                  fontWeight: "bold",
                                }}
                              >
                                מק"ט
                              </Typography>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <Typography
                                variant="caption"
                                sx={{
                                  fontWeight: "bold",
                                }}
                              >
                                תיאור מוצר
                              </Typography>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <Typography
                                variant="caption"
                                sx={{
                                  fontWeight: "bold",
                                }}
                              >
                                כמות
                              </Typography>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <Typography
                                variant="caption"
                                sx={{
                                  fontWeight: "bold",
                                }}
                              >
                                מחיר ליחידה
                              </Typography>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <Typography
                                variant="caption"
                                sx={{
                                  fontWeight: "bold",
                                }}
                              >
                                סה"כ מחיר
                              </Typography>
                            </StyledTableCell>
                          </TableRow>
                          {component.NEO_APIORDERITEMS_SUBFORM.map(
                            (item, itemIndex) => (
                              <TableRow key={itemIndex}>
                                <StyledTableCell align="center" colSpan={1}>
                                  <Typography variant="body2">
                                    {item.PARTNAME}
                                  </Typography>
                                </StyledTableCell>
                                <StyledTableCell align="center" colSpan={1}>
                                  <Typography variant="body2">
                                    {item.PARTDES}
                                  </Typography>
                                </StyledTableCell>
                                <StyledTableCell align="center" colSpan={1}>
                                  <Typography variant="body2">
                                    {item.TQUANT < 0
                                      ? `${Math.abs(item.TQUANT)} -`
                                      : item.TQUANT}
                                  </Typography>
                                </StyledTableCell>
                                <StyledTableCell align="center" colSpan={1}>
                                  <Typography variant="body2">
                                    {`${parseFloat(item.PRICE).toLocaleString(
                                      "en-US",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }
                                    )} ${item.CURRENCIECODE} `}
                                  </Typography>
                                </StyledTableCell>
                                <StyledTableCell align="center" colSpan={1}>
                                  <Typography variant="body2">
                                    {`${parseFloat(
                                      Math.abs(item.QPRICE)
                                    ).toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}${item.QPRICE < 0 ? "-" : ""} ${
                                      item.CURRENCIECODE
                                    }`}
                                  </Typography>
                                </StyledTableCell>
                              </TableRow>
                            )
                          )}
                        </>
                      ) : null}
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Closed Orders Table */}
            {closeorders && closeorders.length > 0 ? (
              <TableContainer component={Paper} sx={{ marginTop: "3rem" }}>
                <Typography
                  sx={{ padding: "5px", backgroundColor: "#dfedf5" }}
                  variant="h6"
                  component="div"
                  align="center"
                >
                  הזמנות סגורות
                </Typography>
                <Table>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell align="center">
                        מספר הזמנה
                      </StyledTableCell>
                      <StyledTableCell align="center">תאריך</StyledTableCell>
                      <StyledTableCell align="center">שם לקוח</StyledTableCell>
                      <StyledTableCell align="center">הזמנתכם</StyledTableCell>
                      <StyledTableCell align="center">סטטוס</StyledTableCell>
                      <StyledTableCell align="center"></StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {closeorders.map((component, index) => (
                      <React.Fragment key={index}>
                        <TableRow
                          key={index}
                          sx={{
                            backgroundColor:
                              expandedClosed === index
                                ? "rgb(219, 217, 217)"
                                : "rgb(245,245,245)",
                          }}
                        >
                          <StyledTableCell
                            align="center"
                            sx={{
                              fontWeight:
                                expandedClosed === index ? "bold" : null,
                              cursor: !component.ERROR ? "pointer" : "default",
                              "&:hover": !component.ERROR
                                ? {
                                    backgroundColor: "#e3f2fd",
                                    color: "#295c9a",
                                  }
                                : {},
                            }}
                            onMouseEnter={(e) => {
                              if (!component.ERROR) {
                                handleOrderNumberHover(e, component.ORDNAME);
                              }
                            }}
                            onMouseLeave={handleClosePopover}
                          >
                            {component.ORDNAME}
                          </StyledTableCell>
                          {!component.ERROR ? (
                            <StyledTableCell
                              align="center"
                              sx={{
                                fontWeight:
                                  expandedClosed === index ? "bold" : null,
                              }}
                            >
                              {moment(component.CURDATE).format("L")}
                            </StyledTableCell>
                          ) : (
                            <StyledTableCell></StyledTableCell>
                          )}
                          <StyledTableCell
                            align="center"
                            sx={{
                              fontWeight:
                                expandedClosed === index ? "bold" : null,
                            }}
                          >
                            {component.CUSTDES}
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            sx={{
                              fontWeight:
                                expandedClosed === index ? "bold" : null,
                            }}
                          >
                            {component.REFERENCE}
                          </StyledTableCell>
                          {!component.ERROR ? (
                            <StyledTableCell
                              align="center"
                              sx={{
                                fontWeight:
                                  expandedClosed === index ? "bold" : null,
                              }}
                            >
                              {cleanAndEncodeHebrew(component.ORDSTATUSDES)}
                            </StyledTableCell>
                          ) : (
                            <StyledTableCell></StyledTableCell>
                          )}
                          {!component.ERROR ? (
                            <TableCell align="center">
                              <IconButton
                                onClick={() => handleExpandClosed(index)}
                              >
                                {expandedClosed === index ? (
                                  <ExpandLessIcon />
                                ) : (
                                  <ExpandMoreIcon />
                                )}
                              </IconButton>
                            </TableCell>
                          ) : (
                            <StyledTableCell></StyledTableCell>
                          )}
                        </TableRow>
                        {expandedClosed === index ? (
                          <>
                            <TableRow>
                              <StyledTableCell align="center">
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: "bold",
                                  }}
                                >
                                  מק"ט
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: "bold",
                                  }}
                                >
                                  תיאור מוצר
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: "bold",
                                  }}
                                >
                                  כמות
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: "bold",
                                  }}
                                >
                                  מחיר ליחידה
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: "bold",
                                  }}
                                >
                                  סה"כ מחיר
                                </Typography>
                              </StyledTableCell>
                            </TableRow>
                            {component.NEO_APIORDERITEMS_SUBFORM.map(
                              (item, itemIndex) => (
                                <TableRow key={itemIndex}>
                                  <StyledTableCell align="center" colSpan={1}>
                                    <Typography variant="body2">
                                      {item.PARTNAME}
                                    </Typography>
                                  </StyledTableCell>
                                  <StyledTableCell align="center" colSpan={1}>
                                    <Typography variant="body2">
                                      {item.PARTDES}
                                    </Typography>
                                  </StyledTableCell>
                                  <StyledTableCell align="center" colSpan={1}>
                                    <Typography variant="body2">
                                      {item.TQUANT < 0
                                        ? `${Math.abs(item.TQUANT)} -`
                                        : item.TQUANT}
                                    </Typography>
                                  </StyledTableCell>
                                  <StyledTableCell align="center" colSpan={1}>
                                    <Typography variant="body2">
                                      {`${parseFloat(item.PRICE).toLocaleString(
                                        "en-US",
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )} ${item.CURRENCIECODE} `}
                                    </Typography>
                                  </StyledTableCell>
                                  <StyledTableCell align="center" colSpan={1}>
                                    <Typography variant="body2">
                                      {`${parseFloat(
                                        Math.abs(item.QPRICE)
                                      ).toLocaleString("en-US", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}${item.QPRICE < 0 ? "-" : ""} ${
                                        item.CURRENCIECODE
                                      }`}
                                    </Typography>
                                  </StyledTableCell>
                                </TableRow>
                              )
                            )}
                          </>
                        ) : null}
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : null}
          </>
        ) : (
          <LoadingBox />
        )}
      </Box>

      {/* Mobile View */}
      <Box
        sx={{
          flexGrow: 1,
          display: { xs: "flex", md: "none" },
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {openorders || closeorders ? (
          <>
            <List>
              {openorders.map((order, index) => (
                <div key={index}>
                  <ListItem>
                    <Container
                      style={{
                        borderRadius: "5px",
                        backgroundColor:
                          expanded === index
                            ? "rgb(219, 217, 217)"
                            : "rgb(245,245,245)",
                      }}
                    >
                      <ListItemButton onClick={() => handleExpand(index)}>
                        <ListItemText sx={{ marginRight: "1rem" }}>
                          <Typography variant="caption">
                            {order.ORDNAME}
                          </Typography>
                        </ListItemText>
                        {!order.ERROR ? (
                          <ListItemText sx={{ marginLeft: "1rem" }}>
                            <Typography variant="caption">
                              {order.CURDATE
                                ? moment(order.CURDATE).format("L")
                                : null}
                            </Typography>
                          </ListItemText>
                        ) : null}
                        {!order.ERROR ? (
                          <ListItemIcon
                            sx={{ paddingLeft: "2rem", marginLeft: "2rem" }}
                            onClick={() => handleExpand(index)}
                          >
                            {expanded === index ? (
                              <ExpandLessIcon />
                            ) : (
                              <ExpandMoreIcon />
                            )}
                          </ListItemIcon>
                        ) : null}
                      </ListItemButton>
                    </Container>
                  </ListItem>

                  <Collapse
                    in={expanded === index}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List sx={{ marginLeft: "1rem" }}>
                      <Typography>
                        סטטוס: {cleanAndEncodeHebrew(order.ORDSTATUSDES)}
                      </Typography>

                      {order.NEO_APIORDERITEMS_SUBFORM.map(
                        (item, itemIndex) => (
                          <List key={itemIndex}>
                            <ListItem>
                              <ListItemText
                                sx={{
                                  marginLeft: "1rem",
                                  paddingBottom: "-1rem",
                                }}
                              >
                                <Typography variant="caption">
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                    }}
                                  >
                                    {item.PARTDES}
                                  </span>
                                </Typography>
                              </ListItemText>
                            </ListItem>
                            <ListItem sx={{ marginLeft: "1rem" }}>
                              <ListItemText>
                                <Typography variant="caption">
                                  מק"ט:
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      paddingRight: "5px",
                                    }}
                                  >
                                    {item.PARTNAME}
                                  </span>
                                </Typography>
                                <div></div>
                                <Typography variant="caption">
                                  כמות:
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      paddingRight: "5px",
                                    }}
                                  >
                                    {item.TQUANT < 0
                                      ? `${Math.abs(item.TQUANT)} -`
                                      : item.TQUANT}
                                  </span>
                                </Typography>
                              </ListItemText>
                              <ListItemText>
                                <Typography variant="caption">
                                  מחיר ליחידה:
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      paddingRight: "5px",
                                    }}
                                  >
                                    {`${parseFloat(item.PRICE).toLocaleString(
                                      "en-US",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }
                                    )} ${item.CURRENCIECODE} `}
                                  </span>
                                </Typography>
                                <div></div>
                                <Typography variant="caption">
                                  סה"כ מחיר:
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      paddingRight: "5px",
                                    }}
                                  >
                                    {`${parseFloat(
                                      Math.abs(item.QPRICE)
                                    ).toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}${item.QPRICE < 0 ? "-" : ""} ${
                                      item.CURRENCIECODE
                                    }`}
                                  </span>
                                </Typography>
                              </ListItemText>
                            </ListItem>
                            <Divider light variant="middle" />
                          </List>
                        )
                      )}
                    </List>
                  </Collapse>
                </div>
              ))}
            </List>

            <List>
              {closeorders.map((order, index) => (
                <div key={index}>
                  <ListItem>
                    <Container
                      style={{
                        borderRadius: "5px",
                        backgroundColor:
                          expanded === index
                            ? "rgb(219, 217, 217)"
                            : "rgb(245,245,245)",
                      }}
                    >
                      <ListItemButton onClick={() => handleExpand(index)}>
                        <ListItemText sx={{ marginRight: "1rem" }}>
                          <Typography variant="caption">
                            {order.ORDNAME}
                          </Typography>
                        </ListItemText>
                        {!order.ERROR ? (
                          <ListItemText sx={{ marginLeft: "1rem" }}>
                            <Typography variant="caption">
                              {order.CURDATE
                                ? moment(order.CURDATE).format("L")
                                : null}
                            </Typography>
                          </ListItemText>
                        ) : null}
                        {!order.ERROR ? (
                          <ListItemIcon
                            sx={{ paddingLeft: "2rem", marginLeft: "2rem" }}
                            onClick={() => handleExpand(index)}
                          >
                            {expanded === index ? (
                              <ExpandLessIcon />
                            ) : (
                              <ExpandMoreIcon />
                            )}
                          </ListItemIcon>
                        ) : null}
                      </ListItemButton>
                    </Container>
                  </ListItem>

                  <Collapse
                    in={expanded === index}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List sx={{ marginLeft: "1rem" }}>
                      <Typography>
                        סטטוס: {cleanAndEncodeHebrew(order.ORDSTATUSDES)}
                      </Typography>
                      {order.NEO_APIORDERITEMS_SUBFORM.map(
                        (item, itemIndex) => (
                          <List key={itemIndex}>
                            <ListItem>
                              <ListItemText
                                sx={{
                                  marginLeft: "1rem",
                                  paddingBottom: "-1rem",
                                }}
                              >
                                <Typography variant="caption">
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                    }}
                                  >
                                    {item.PARTDES}
                                  </span>
                                </Typography>
                              </ListItemText>
                            </ListItem>
                            <ListItem sx={{ marginLeft: "1rem" }}>
                              <ListItemText>
                                <Typography variant="caption">
                                  מק"ט:
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      paddingRight: "5px",
                                    }}
                                  >
                                    {item.PARTNAME}
                                  </span>
                                </Typography>
                                <div></div>
                                <Typography variant="caption">
                                  כמות:
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      paddingRight: "5px",
                                    }}
                                  >
                                    {item.TQUANT < 0
                                      ? `${Math.abs(item.TQUANT)} -`
                                      : item.TQUANT}
                                  </span>
                                </Typography>
                              </ListItemText>
                              <ListItemText>
                                <Typography variant="caption">
                                  מחיר ליחידה:
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      paddingRight: "5px",
                                    }}
                                  >
                                    {`${parseFloat(item.PRICE).toLocaleString(
                                      "en-US",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }
                                    )} ${item.CURRENCIECODE} `}
                                  </span>
                                </Typography>
                                <div></div>
                                <Typography variant="caption">
                                  סה"כ מחיר:
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      paddingRight: "5px",
                                    }}
                                  >
                                    {`${parseFloat(
                                      Math.abs(item.QPRICE)
                                    ).toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}${item.QPRICE < 0 ? "-" : ""} ${
                                      item.CURRENCIECODE
                                    }`}
                                  </span>
                                </Typography>
                              </ListItemText>
                            </ListItem>
                            <Divider light variant="middle" />
                          </List>
                        )
                      )}
                    </List>
                  </Collapse>
                </div>
              ))}
            </List>
          </>
        ) : (
          <LoadingBox />
        )}
      </Box>

      {/* ✅ Tracking Popover - RTL + צבעי האתר */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        disableScrollLock={true}
        disableRestoreFocus={true}
        sx={{
          pointerEvents: "none",
        }}
        PaperProps={{
          sx: {
            pointerEvents: "auto",
            // ✅ רוחב דינמי לפי מספר השלבים
            width:
              timeline.length <= 3
                ? 500
                : timeline.length === 4
                ? 600
                : timeline.length === 5
                ? 700
                : 800,
            maxHeight: 500,
            borderRadius: 3,
            boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
            overflow: "visible",
          },
          onMouseEnter: handlePopoverMouseEnter,
          onMouseLeave: handleClosePopover,
        }}
      >
        <Box sx={{ p: 3 }}>
          <Typography
            variant="h6"
            fontWeight={700}
            sx={{
              mb: 3,
              textAlign: "center",
              color: "#295c9a",
              fontSize: "1.2rem",
            }}
          >
            {currentOrderNumber} : מעקב הזמנה
          </Typography>

          <Divider sx={{ mb: 3 }} />

          {trackingLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                py: 4,
              }}
            >
              <CircularProgress />
            </Box>
          ) : trackingError ? (
            <Alert severity="error" sx={{ borderRadius: 2 }}>
              {trackingError}
            </Alert>
          ) : timeline.length > 0 ? (
            <Box
              sx={{
                position: "relative",
                pt: 4,
                pb: 2,
                direction: "rtl",
              }}
            >
              {/* Timeline Line */}
              <Box
                sx={{
                  position: "absolute",
                  top: 70,
                  // ✅ התאמת padding לפי מספר שלבים
                  left: timeline.length <= 3 ? "12%" : "8%",
                  right: timeline.length <= 3 ? "12%" : "8%",
                  height: 3,
                  background: "rgb(223, 237, 245)",
                  zIndex: 0,
                }}
              />

              {/* Progress Line - RTL */}
              <Box
                sx={{
                  position: "absolute",
                  top: 70,
                  // ✅ התאמת padding לפי מספר שלבים
                  right: timeline.length <= 3 ? "12%" : "8%",
                  width: `${
                    ((timeline.findIndex((s) => s.status === "current") || 0) /
                      (timeline.length - 1)) *
                    (timeline.length <= 3 ? 76 : 84)
                  }%`,
                  height: 3,
                  background:
                    "linear-gradient(90deg, rgb(223, 237, 245) 0%, rgba(41, 92, 154, 0.3) 100%)",
                  zIndex: 1,
                  transition: "width 0.8s ease-in-out",
                }}
              />

              {/* Steps */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  position: "relative",
                  zIndex: 2,
                  // ✅ התאמת padding לפי מספר שלבים
                  px: timeline.length <= 3 ? 4 : 2,
                }}
              >
                {[...timeline].reverse().map((step, index) => {
                  const colors = getStepColor(step.status);
                  const StepIcon = step.icon;

                  return (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                        position: "relative",
                      }}
                    >
                      {step.date && (
                        <Typography
                          variant="caption"
                          sx={{
                            position: "absolute",
                            top: -30,
                            color: "#295c9a",
                            fontWeight: 700,
                            fontSize: "0.7rem",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {formatDate(step.date)}
                        </Typography>
                      )}

                      <Box
                        sx={{
                          width: step.status === "current" ? 60 : 50,
                          height: step.status === "current" ? 60 : 50,
                          borderRadius: "50%",
                          background:
                            step.status === "current"
                              ? "#65b891"
                              : step.status === "completed"
                              ? "#295c9a"
                              : "rgb(223, 237, 245)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow:
                            step.status === "current"
                              ? "0 6px 20px rgba(101, 184, 145, 0.4)"
                              : step.status === "completed"
                              ? "0 3px 12px rgb(223, 237, 245)"
                              : "none",
                          transition: "all 0.3s ease",
                          animation:
                            step.status === "current"
                              ? "pulse 2s infinite"
                              : "none",
                          "@keyframes pulse": {
                            "0%, 100%": {
                              transform: "scale(1)",
                            },
                            "50%": {
                              transform: "scale(1.05)",
                            },
                          },
                          border:
                            step.status === "future"
                              ? "2px solid rgba(41, 92, 154, 0.4)"
                              : step.status === "current"
                              ? "3px solid #65b891"
                              : "none",
                        }}
                      >
                        <StepIcon
                          sx={{
                            color:
                              step.status === "future" ? "#295c9a" : "white",
                            fontSize: step.status === "current" ? 28 : 24,
                          }}
                        />
                      </Box>

                      <Typography
                        variant="body2"
                        sx={{
                          mt: 1.5,
                          fontWeight: 700,
                          color: "#295c9a",
                          textAlign: "center",
                          fontSize: "0.8rem",
                          maxWidth: 90,
                        }}
                      >
                        {step.name}
                      </Typography>

                      {step.status === "current" && (
                        <Box
                          sx={{
                            mt: 0.5,
                            px: 1.5,
                            py: 0.3,
                            borderRadius: 1.5,
                            background:
                              "linear-gradient(135deg, #65b891 0%, #65b891 100%)",
                            color: "white",
                            fontSize: "0.65rem",
                            fontWeight: 700,
                          }}
                        >
                          נוכחי
                        </Box>
                      )}

                      {step.status === "completed" && (
                        <CheckCircle
                          sx={{
                            mt: 0.5,
                            color: "#295c9a",
                            fontSize: 16,
                          }}
                        />
                      )}
                    </Box>
                  );
                })}
              </Box>
            </Box>
          ) : (
            <Box sx={{ textAlign: "center", py: 3 }}>
              <Typography variant="body2" color="text.secondary">
                אין מידע זמין עבור הזמנה זו
              </Typography>
            </Box>
          )}
        </Box>
      </Popover>
    </Container>
  );
};

export default OpenList;
